var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgP14(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.33203 16C3.33203 10.0289 3.33203 7.0433 5.18702 5.1883C7.04202 3.33331 10.0276 3.33331 15.9987 3.33331C21.9698 3.33331 24.9554 3.33331 26.8104 5.1883C28.6654 7.0433 28.6654 10.0289 28.6654 16C28.6654 21.971 28.6654 24.9566 26.8104 26.8117C24.9554 28.6666 21.9698 28.6666 15.9987 28.6666C10.0276 28.6666 7.04202 28.6666 5.18702 26.8117C3.33203 24.9566 3.33203 21.971 3.33203 16Z",
    stroke: "#F63C47",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22 16C22 19.3137 19.3137 22 16 22C12.6863 22 10 19.3137 10 16C10 12.6863 12.6863 10 16 10C19.3137 10 22 12.6863 22 16Z",
    stroke: "#F63C47",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.344 8.66669H23.332",
    stroke: "#F63C47",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgP14);
export default __webpack_public_path__ + "static/media/p14.5703874f64522f3fd9ed6cfdc8cd65f7.svg";
export { ForwardRef as ReactComponent };